import React from 'react'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'

const Tags = ({ tags }) => (
  <>
    {tags.map((x, i) => (
      <Link key={`tag-${i}`} className="tag" to={`/tags/${kebabCase(x)}/`}>
        {x}
      </Link>
    ))}
  </>
)

export default Tags
